export default __webpack_public_path__ + "static/media/img--design-4.0061ad4b.jpg";